import { useDispatch } from "../../redux/hooks";
import { discardTestkit } from "../../redux/slices/testkit";
import { DialogCloseHandler } from "../../types/dialog";
import { Testkit } from "../../types/testkit";
import BaseDialog from "../../components/dialogs/BaseDialog";

const DialogDiscardKit = ({
  testkit,
  open,
  onClose,
}: {
  testkit?: Testkit,
  open: boolean,
  onClose?: DialogCloseHandler,
}) => {
  const dispatch = useDispatch();
  
  const handleConfirm = () => {
    if (!testkit) return;

    dispatch(discardTestkit({ testkit }))
    .then(() => { onClose?.({}, 'closeClick') });
  }

  return (
    <BaseDialog
      title={`Discard kit ${testkit?.id} and prevent it from being issued to a user`}
      width={300}
      open={open}
      onClose={onClose}
      onConfirm={handleConfirm}
    />
  );
}

export default DialogDiscardKit;